export default function MissionApproach() {
  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative overflow-hidden rounded-2xl aspect-[4/5] lg:aspect-[5/6]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20macro%20photography%20of%20precision%20machined%20aluminum%20surface%20with%20fine%20geometric%20grooves%20and%20soft%20warm%20lighting%2C%20brushed%20metal%20texture%2C%20minimalist%20industrial%20design%2C%20cream%20and%20charcoal%20color%20palette%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20abstract%20material%20study%2C%20artistic%20product%20photography%20style&width=1000&height=1200&seq=mission-approach-technopankai&orientation=portrait"
                alt="Precision machined surface with fine geometric texture"
                title="Engineering precision and quality"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col gap-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="font-label text-xs tracking-widest uppercase text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full">Our Approach</span>
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
                Engineering with<br />
                <span className="text-accent-500">intention &amp; precision</span>
              </h2>
            </div>

            <div className="bg-foreground-950 rounded-2xl p-8 md:p-10 flex flex-col gap-6">
              <span className="font-label text-xs tracking-widest uppercase text-accent-400">Our Mission</span>
              <p className="font-body text-base md:text-lg text-background-100/90 leading-relaxed">
                We follow modern software engineering practices, including clean architecture, performance optimization, and user-centered design. Every system we build is grounded in technical excellence, designed to scale, and built to last.
              </p>
              <p className="font-body text-base text-background-200/80 leading-relaxed">
                The team emphasizes continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions. We actively explore new technologies and evolve our internal processes to maintain high technical excellence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}